import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../utils/history';
import PageHeader from "../shared/page-header";
import {
    Grid,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableContainer,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { getPackagesSelector, getPackages, clearPackage, deletePackage } from '../../store/admin';
import { TablePaginationActions } from '../shared/pagination';
import { EnhancedTableHead, stableSort, getSorting } from '../shared/tableHeader';
import EditButton from '../shared/edit-button';
import DeleteButton from '../shared/delete-button/delete-button-view';

const useStyles = makeStyles(theme => ({
    button: theme.button
}));


const PackageManagement = ({ ...props }) => {

    const classes = useStyles();      
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [open, setOpen] = React.useState(false);
    const [selectedPackageId, setSelectedPackageId] = React.useState(0);

    
    useEffect(() => {
        const init = async () => {
            const { getPackages, clearPackage } = props;
            await getPackages();
            clearPackage();
        }
        init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        setOpen(false);
        setSelectedPackageId(0);
    };

    const onDelete = (id) => {
        setSelectedPackageId(id);
        setOpen(true);
    }

    const handleConfirmDelete = async () => {

        const {deletePackage, clearPackage} = props;
        await deletePackage(selectedPackageId)
        clearPackage();
        setOpen(false);
    }

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = e => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };    

    const handleRequestSort = (e, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };
    
    const onEdit = (id) => {
        history.push(`/package/${id}`);
    }

    const headCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
        { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
        { id: 'isConsentPackage', numeric: false, disablePadding: false, label: 'Consent Package' },
        { id: 'edit', numeric: false, disablePadding: false, label: '' },
        { id: 'delete', numeric: false, disablePadding: false, label: '' },
    ];
    
    return (
        <Fragment>
            <PageHeader
                title="Packages"
                description="Manage sleep-study packages and the forms they include."
                action={
                    <Button variant="contained" type="button" color="secondary" onClick={e => history.push(`/package/new`)}>Add Package</Button>
                }
            />
            { props.packages &&
                <Grid item xs={12} style={{overflow: "auto"}}>
                    
                    <TableContainer>
                        <Table 
                            className={classes.table}
                            size="small"
                            aria-labelledby="forms"
                            aria-label="enhanced table">
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={props.packages.length}
                                    headCells={headCells}
                                    />
                                <TableBody>
                                    {stableSort(props.packages, getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(_package => {
                                            return (
                                                <TableRow key={_package.id}  className={classes.tableRow}>
                                                    <TableCell component="th" scope="row" >{_package.id}</TableCell>
                                                    <TableCell component="th" scope="row" >{_package.name}</TableCell>
                                                    <TableCell component="th" scope="row" >{_package.isConsentPackage ? "True" : "False"}</TableCell>
                                                    <TableCell component="th" scope="row" ><EditButton pid={_package.id} handleEdit={onEdit} /></TableCell>
                                                    <TableCell component="th" scope="row" ><DeleteButton pid={_package.id} handleDelete={onDelete} /></TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                        </Table>                    
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25,100]}
                        component="div"
                        count={props.packages.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </Grid>   
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete Package"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete selected package?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant="contained" onClick={handleConfirmDelete} color="primary">
                    Yes
                </Button>
                <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                    No
                </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );    
}

const mapStateToProps = state => {

    return {
        packages: getPackagesSelector(state)
    };

};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ getPackages, clearPackage, deletePackage }, dispatch)   
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PackageManagement)